export default {
  campagne: 'Le nostre campagne',
  published: 'Pubblicato il',
  archivio: 'Archivio News',
  notizieCorrelate: 'Notizie correlate',
  modalitaDusoVino: "Modalità d'uso <br /> dei lieviti per <i>vino</i>",
  modalitaDusoBirra: "Modalità d'uso <br /> dei lieviti per <i>birra</i>",
  buy: 'Acquista',
  richiediInfo: 'Richiedi info',
  etichettaAmbientale: 'Etichetta Ambientale',
  what: "Cos'è",
  where: 'Dove va',
  raccoltaPlastica: 'Raccolta plastica',
  disposizioni: 'Verifica le disposizioni del tuo comune',
  disposizioniInfo:
    'Prodotto per uso professionale enologico conforme a: Reg. CEE/UE N°934/2019 e International Codex OIV',
  applicazioni: 'Applicazioni',
  specificheTecniche: 'Specifiche tecniche',
  preparazione: 'Preparazione',
  scaricaScheda: 'Scarica scheda tecnica',
  scaricaSchedaPanificati: 'Scheda Tecnica - Ricette',
  contenitore: 'Contenitore',
  tappo: 'Tappo',
  sottotappo: 'Sottotappo',
  tappoFlacone: 'Tappo flacone',
  tappoTanica: 'Tappo tanica',
  sacchetto: 'Sacchetto',
  vediNews: 'Archivio News',
  vediVideo: 'Tutti i video',
  news: 'News',
  videos: 'Video',
  leggi: 'Continua a leggere',
  indietro: 'Indietro',
  seeAll: 'Vedi tutti',
  filtri: 'Filtri',
  approfondisci: 'Approfondisci',
  prodotto: 'Vai al prodotto',
  cancellaFiltri: 'Cancella filtri',
  modelTitle: 'I nostri Atecnos: pionieri nella rivoluzione dei lieviti',
  modelText:
    'Nel 2012 abbiamo introdotto, per primi, i lieviti in crema sul mercato. Atecnos si distingue grazie a una metodologia esclusiva: l’inoculo diretto, che riproduce fedelmente i processi naturali di moltiplicazione del lievito, garantendo un prodotto di purezza microbiologica superiore.',
  iubendaCookiePolicyId: '80110551',
}
